import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const InventarioInicialApi = () => {
    const [cargando, setCargando] = useState(false);

    const getInventariosIniciales = async (idInventario) => {
        try {
            setCargando(true);
            const response = await api.get(
                `historico_inventarios/inventarios_iniciales`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const upsertInventariosIniciales = async (datos) => {
        try {
            setCargando(true);
            const response = await api.post(
                `historico_inventarios/inventarios_iniciales`,
                datos,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getInventariosIniciales,
        upsertInventariosIniciales,

        cargando,
    };
};
